import { useState } from 'react';

type Props = {
  open: boolean;
  initialKey: string;
  hasStoredKey: boolean;
  onClose: () => void;
  onSave: (key: string) => void;
  onClear: () => void;
  onTest: (key: string) => void;
};

export function ApiKeyModal({
  open,
  initialKey,
  hasStoredKey,
  onClose,
  onSave,
  onClear,
  onTest,
}: Props) {
  const [draft, setDraft] = useState(initialKey);
  if (!open) return null;
  return (
    <div className="absolute inset-0 bg-black/60 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-3xl w-96 text-center animate-pop-in border-4 border-purple-400 shadow-2xl">
        <h3 className="font-bold mb-2 text-purple-800 text-xl">設定 Google Gemini API 金鑰</h3>
        <p className="text-xs text-gray-500 mb-4">
          設定金鑰後即可使用 AI 出題與講評功能。
          <br />
          <a
            href="https://aistudio.google.com/app/apikey"
            target="_blank"
            rel="noreferrer"
            className="text-blue-500 underline font-bold"
          >
            👉 點此免費申請金鑰
          </a>
        </p>
        <input
          type="text"
          placeholder="貼上您的 API Key (AIza...)"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          className="w-full p-3 border-2 border-purple-200 rounded-xl mb-4 text-center focus:outline-none focus:border-purple-500 bg-purple-50 font-mono text-sm"
        />
        <div className="flex gap-2 mb-2">
          <button onClick={onClose} className="flex-1 bg-gray-200 py-2 rounded-lg font-bold">
            取消
          </button>
          <button
            onClick={() => onSave(draft)}
            className="flex-1 bg-purple-500 text-white py-2 rounded-lg font-bold hover:bg-purple-600"
          >
            儲存設定
          </button>
          <button
            onClick={() => onTest(draft)}
            className="flex-1 bg-blue-500 text-white py-2 rounded-lg font-bold hover:bg-blue-600"
          >
            測試連線
          </button>
        </div>
        {hasStoredKey && (
          <button
            onClick={onClear}
            className="text-xs text-red-400 underline hover:text-red-600 w-full"
          >
            清除已儲存的金鑰
          </button>
        )}
      </div>
    </div>
  );
}
